import { render } from "./WithBorders.vue?vue&type=template&id=4be7cad2"
import script from "./WithBorders.vue?vue&type=script&lang=js"
export * from "./WithBorders.vue?vue&type=script&lang=js"
script.render = render

export default script